<script>
  import { valueModifies } from '@/utils'
  import _ from 'lodash'
  import mixins from './mixins'
  export default {
    name: 'VDatePicker',
    mixins: [mixins],
    data() {
      return {}
    },

    render() {
      return (
        <ElFormItem
          prop={this.prop}
          rules={this.explainValidate()}
          label-width="0"
        >
          <ElDatePicker
            class={this.config.class}
            type={this.config.type}
            value={_.get(this.row, this.column.prop)}
            valueFormat={this.config.value_format}
            format={this.config.format}
            onInput={(value) => {
              _.set(
                this.row,
                this.column.prop,
                valueModifies(this.config.modelModifiers, value)
              )
              if (this.config.onInput) {
                //解析prop 获取到父表的行索引，以及目前所在的行索引

                this.config.onChange(
                  this.tableRoot.tableData,
                  this.row,
                  this.column,
                  this.prop.split('.'),
                  value
                )
              }
            }}
          />
        </ElFormItem>
      )
    },
  }
</script>
